import { map, filter, delay } from 'rxjs/operators';
// ---- external imports -----

import * as hintsActions from './actions';
import * as hintsActionTypes from './actionTypes';
// ---- local imports -----

const hintsEpic = (action$) => action$.pipe(
	filter((action) => !action.type.includes('@@')
        && !action.type.startsWith(hintsActionTypes.PREFIX)),
	// Asynchronously wait 1ms for UI to adjust elements positions 
	// before showing hints to fix arrow_month3_prep_logbook_purchase_products 
	// not showing correctly
	delay(1),
	map((action) => hintsActions.reactToEmittedAction(action.type))
);

export default hintsEpic;
